document.documentElement.classList.add('js');

/* Self-contained so the block behaves the same on all four concepts, including
   the one with no reveal observer of its own. Written to survive the Shopify
   build, which strips scripts out of the body and concatenates them into one
   asset file — so no document.currentScript, and no assumption about when it
   runs relative to the markup. */
(function(){
  document.documentElement.classList.add('ch-js');
  function start(){
    var els = [].slice.call(document.querySelectorAll('.ch'));
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, {threshold:0.15});
    els.forEach(function(el){ io.observe(el); });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

(function(){
  var $  = function(s,r){return (r||document).querySelector(s);};
  var $$ = function(s,r){return [].slice.call((r||document).querySelectorAll(s));};
  var REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;

  if('IntersectionObserver' in window && !REDUCED){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        var el = e.target;
        var sibs = el.parentElement ? [].slice.call(el.parentElement.children)
                     .filter(function(c){return c.classList.contains('rev');}) : [];
        setTimeout(function(){ el.classList.add('in'); },
                   Math.min(Math.max(sibs.indexOf(el),0),4) * 90);
        io.unobserve(el);
      });
    }, {threshold:.12, rootMargin:'0px 0px -5% 0px'});
    $$('.rev').forEach(function(el){ io.observe(el); });
  } else {
    $$('.rev').forEach(function(el){ el.classList.add('in'); });
  }

  var form = $('#enquiry');
  if(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      $$('.err', form).forEach(function(n){ n.remove(); });
      var bad = $$('[required]', form).filter(function(f){ return !f.value.trim(); });
      if(bad.length){
        bad.forEach(function(f){
          var m = document.createElement('div');
          m.className = 'err'; m.textContent = 'We need this one';
          f.parentNode.appendChild(m);
        });
        bad[0].focus();
        return;
      }
      var note = $('.formnote', form);
      if(note){ note.textContent = 'Got it — we’ll be back within one working day.'; }
      form.reset();
    });
  }
})();
